import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'

export const ColumnaMateriales = () => {

  return (
    <TableRow>
      <TableCell align="left"></TableCell>
      <TableCell align="left">Fecha</TableCell>
      <TableCell align="left">Id Solicitud</TableCell>
      <TableCell align="left">Carnet</TableCell>
      <TableCell align="left">Apellido y Nombre</TableCell>
      <TableCell align="left">Edad</TableCell>
      <TableCell align="left">Material</TableCell>
      <TableCell align="left">Cantidad</TableCell>
      <TableCell align="left">Disponible</TableCell>
      <TableCell align="left">Cantidad Cotizada</TableCell>
      <TableCell align="left">Valor Unitario</TableCell>
      <TableCell align="left">Imagenes</TableCell>
    </TableRow>


  )
}
